import axios from 'axios';
import { call, put, takeEvery, delay } from 'redux-saga/effects';
import * as A from '../actions/fixRecordAction';
import { API_PATH }  from '../config';
import { authHeader } from '../helper/authHeader';

const FIXRECORD_API = `${API_PATH}/fixrecord`;


const getfixRecordApi = (station, page, per_page) => {
   let params = [];
   let url = `${FIXRECORD_API}`;
   if (station) params.push(`id=${station}`);
   if (page) params.push(`page=${page}`);
   if (per_page) params.push(`per_page=${per_page}`);
   if (params.length > 0)
      url = url + '?' + params.join('&');
   return axios.get(url, 
      {
         headers: {...authHeader()},
         timeout: 5000
      }).then( (response) => response.data);
}

function* getFixRecord(action) {

   let fetch = undefined;
   try {
      fetch = yield call(getfixRecordApi, action.station, action.page, action.per_page);
      if (fetch) {
         if (fetch.success) {
            yield put(A.fixrecordListSuccess({result: fetch.result}));
         } else {
            yield put(A.fixrecordListFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(A.fixrecordListFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(A.fixrecordListFailure(`資料錯誤, ${error.message}`));
   }
}

const addfixRecordApi = (data) => {
   console.log(data)
   let url = `${FIXRECORD_API}`;
   return axios.post(url, data,
      {
         headers: {...authHeader()},
         timeout: 5000
      }).then( (response) => response.data);
}

function* addFixRecord(action) {

   let fetch = undefined;
   try {

      fetch = yield call(addfixRecordApi, action.data);
      if (fetch) {

         if (fetch.success) {
            yield put(A.fixrecordAddSuccess({result: fetch.result}));
         } else {
            yield put(A.fixrecordAddFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(A.fixrecordAddFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(A.fixrecordAddFailure(`資料錯誤, ${error.message}`));
   }
}

const deletefixRecordApi = (station, id, page, per_page) => {
   let url = `${FIXRECORD_API}?id=${station}&num=${id}&page=${page}&per_page=${per_page}`;
   return axios.delete(url,
      {
         headers: {...authHeader()},
         timeout: 5000
      }).then( (response) => response.data);
}

function* deleteFixRecord(action) {

   let fetch = undefined;
   try {
      console.log(action)
      fetch = yield call(deletefixRecordApi, action.station, action.id, action.page, action.per_page);
      if (fetch) {

         if (fetch.success) {
            yield put(A.fixrecordDeleteSuccess({result: fetch.result}));
         } else {
            yield put(A.fixrecordDeleteFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(A.fixrecordDeleteFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(A.fixrecordDeleteFailure(`資料錯誤, ${error.message}`));
   }
}

export default function* watchFixRecordAction() {
   yield takeEvery(A.FIXRECORD_LIST_REQUEST, getFixRecord);
   yield takeEvery(A.FIXRECORD_ADD_REQUEST, addFixRecord);
   yield takeEvery(A.FIXRECORD_DELETE_REQUEST, deleteFixRecord);
}